import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import ResetPasswordForm from "./reset-passwords-form";
import ResetPasswordsData from "./reset-passwords-data";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

const ResetPasswords = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_RESET_PASSWORDS",
      "SUPERVISOR_RESET_PASSWORDS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("RESET_PASSWORD")}
        subTitle={i18n.get("RESET_ADMIN_PASSWORDS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <ResetPasswordForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ResetPasswordsData />
    </ET3PageDiv>
  );
});

export default ResetPasswords;
